import { HOME_ROUTE, IDM_ROLES_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { LayoutPages } from "../layoutPages";
import { IdmRolesWidget } from "../../widgets/idmRoles";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";

export default function IdmRolesPage() {
    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.STAFF)
        && hasFeature(my, FEATURES.IDM.ROLES_LIST)

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={IDM_ROLES_ROUTE.name}>
            <IdmRolesWidget />
        </LayoutPages>
    )
}
